/** Root folder for marketing demo videos on Vercel Blob */
export const LANDING_DEMO_BLOB_PREFIX = 'NINX/landing/demos'

/**
 * baby: Public Blob store host (no trailing slash).
 * Override via NEXT_PUBLIC_VERCEL_BLOB_HOST if the store changes.
 */
export const LANDING_DEMO_BLOB_HOST =
  process.env.NEXT_PUBLIC_VERCEL_BLOB_HOST ??
  'https://2mjii5xz7qwzm2qx.public.blob.vercel-storage.com'

/**
 * baby: Registry of demo assets: value is `{slug}/{filename}` under LANDING_DEMO_BLOB_PREFIX.
 * Upload with: pnpm --filter @nin/terminal landing:upload-demo -- --file .. --slug voice-browser --name ninxl_voice_browser_f0.mp4
 */
export const LANDING_DEMO_FILES = {
  ninxlVoiceBrowserF0: 'voice-browser/ninxl_voice_browser_f0.mp4',
  ninxlVoiceBrowserF1: 'voice-browser/ninxl_voice_browser_f1.mp4',
  /** InkFlow system-wide dictation demo: /nink hero Play demo */
  ninxlInkflow: 'inkflow/ninxl_inkflow.mp4',
  /** Papercraft explainer: /nin + /ninxl scroll-world first section */
  ninxExplainerV2: 'explainer/ninx-explainer_v2.mp4',
  ninxExplainerV2Poster: 'explainer/ninx-explainer_v2_poster.png',
} as const

export type LandingDemoKey = keyof typeof LANDING_DEMO_FILES

/** Full Blob pathname, e.g. NINX/landing/demos/voice-browser/ninxl_voice_browser_f0.mp4 */
export function getLandingDemoBlobPath(key: LandingDemoKey): string {
  return `${LANDING_DEMO_BLOB_PREFIX}/${LANDING_DEMO_FILES[key]}`
}

/** Public CDN URL for a registered landing demo */
export function getLandingDemoUrl(key: LandingDemoKey): string {
  return `${LANDING_DEMO_BLOB_HOST}/${getLandingDemoBlobPath(key)}`
}

/** Hero "Play demo" on /nin org landing */
export const NIN_HERO_DEMO_SRC = getLandingDemoUrl('ninxlVoiceBrowserF0')

/** InkFlow demo on Blob: /nink hero Play demo + demo tabs */
export const NINXL_INKFLOW_DEMO_SRC = getLandingDemoUrl('ninxlInkflow')

/** Alias for /nink Ink Flow demo (same Blob asset) */
export const NINK_INKFLOW_DEMO_SRC = NINXL_INKFLOW_DEMO_SRC

/** Hero "Play demo" on /ninxl landing: voice-browser clip (keep this animation) */
export const NINXL_HERO_DEMO_SRC = getLandingDemoUrl('ninxlVoiceBrowserF1')

/** Hero "Play demo" on /nink landing. InkFlow clip */
export const NINK_HERO_DEMO_SRC = NINK_INKFLOW_DEMO_SRC

/** Explainer video on /nin + /ninxl scroll-world first viewport */
export const NINX_EXPLAINER_DEMO_SRC = getLandingDemoUrl('ninxExplainerV2')

/** Poster frame for the scroll-world explainer dialog */
export const NINX_EXPLAINER_POSTER_SRC = getLandingDemoUrl('ninxExplainerV2Poster')

/** @deprecated use NINXL_HERO_DEMO_SRC on /ninxl or NIN_HERO_DEMO_SRC on /nin */
export const NINX_HERO_DEMO_SRC = NINXL_HERO_DEMO_SRC
